import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher } from '@angular/router';

import { AuthContainerComponent } from './containers/auth-container/auth-container.component';
import { HandleLoginContainerComponent } from './containers/handle-login/handle-login-container.component';
import { LogoutContainerComponent } from './containers/logout-container/logout-container.component';
import { SkipLoginGuard } from './guards/skip-login.guard';
import { LoginRouteMatcher, LogoutRouteMatcher } from './matchers/route-matchers';

const routes: Routes = [
    {
        matcher: LoginRouteMatcher as UrlMatcher,
        canActivate: [SkipLoginGuard],
        component: AuthContainerComponent
    },
    {
        matcher: LogoutRouteMatcher as UrlMatcher,
        component: LogoutContainerComponent
    },
    {
        path: 'redirect',
        component: HandleLoginContainerComponent
    },
    {
        path: '**',
        redirectTo: '../login'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthenticationRoutingModule {}
